/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'

expocadfx.printExhibitors = function(exhibitors, filter, viewName, exhibitorLabel, boothLabel) {
    var obj = {};
    var numExhibitors = exhibitors.length;
    
    //////   style for exhibitor table
    obj.style = "td, th{padding:0.2em 0.5em;text-align:left;}";
    
    //  create a html table of exhibitors with booth numbers
    obj.content = document.createElement( "div");
    var table = document.createElement( "table");
    var tableHead = document.createElement( "thead");
    var hdrRow = document.createElement( "tr");
    var colHd = null;
    var i = 0;
    var row = null;
    var tb = document.createElement( "tbody");
    
    function makeRow( d1, d2) {
        var row = document.createElement( "tr");
        var cell = document.createElement( "td");
        cell.textContent = d1;
        row.appendChild( cell);
        cell = document.createElement( "td");
        cell.textContent = d2;
        row.appendChild( cell);
        return row;
    }
    
    
    obj.content.appendChild( table);
    
    colHd = document.createElement( "th");
    colHd.textContent = exhibitorLabel;
    hdrRow.appendChild( colHd);
    colHd = document.createElement( "th");
    colHd.textContent = boothLabel;
    hdrRow.appendChild( colHd);
    tableHead.appendChild( hdrRow);
    table.appendChild( tableHead);
    table.appendChild( tb);
    
    for( i = 0; i < numExhibitors; i++) {
		//  use exhibitor list filter
		if( filter === "tag" && exhibitors[i].favorite ||
			filter === "available" && exhibitors[i].bAvailable ||
			filter === "hall" && !exhibitors[i].bAvailable && 
				exhibitors[i].viewName === viewName ||
			filter === "all" && !exhibitors[i].bAvailable) {
			
            row = makeRow( exhibitors[i].name, exhibitors[i].location);
            tb.appendChild( row);
        }
    }
    
    return obj;
};